export const SAVE_ISSUE = "SAVE_ISSUE";
export const EDIT_ISSUE = "EDIT_ISSUE";
export const PUSH_ISSUES = "PUSH_ISSUES";
export const SET_ISSUE = "SET_ISSUE";
